module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/contact-collector-panel-desktop-55199613727c6c339fa6b38835f707cb.jpg";